import { isPolygonWithinBounds } from "../map/mapUtils";

export const validateGenericInfo = (data) => {
  const errors = {};

  if (!data || !data.fieldName) {
    errors.fieldName = "Il nome del terreno è obbligatorio.";
  }
  if (!data || !data.fieldType) {
    errors.fieldType = "La tipologia del terreno è obbligatoria.";
  }

  return Object.keys(errors).length > 0 ? errors : null;
};

export const validateCropHistory = (data) => {
  const errors = {};

  if (!data || !Array.isArray(data)) {
    return { general: "Dati non validi" };
  }

  data.forEach((row, index) => {
    const rowErrors = {};
    if (!row.culture) {
      rowErrors.culture = "La coltura è obbligatoria";
    }
    if (!row.startDate) {
      rowErrors.startDate = "Inserire data di inizio";
    }
    if (!row.endDate) {
      rowErrors.endDate = "Inserire data di fine";
    }
    if (
      row.startDate &&
      row.endDate &&
      new Date(row.startDate) > new Date(row.endDate)
    ) {
      rowErrors.endDate =
        "La data di fine deve essere successiva alla data di inizio";
    }

    if (Object.keys(rowErrors).length > 0) {
      errors[`row_${row.id}`] = rowErrors;
    }
  });

  return Object.keys(errors).length > 0 ? errors : null;
};

export const validateFieldMap = (formData, setMapError) => {
  const mapData = formData.Mappa;
  if (
    !mapData ||
    !mapData.polygonCoordinates ||
    mapData.polygonCoordinates.length === 0
  ) {
    setMapError("È necessario disegnare un poligono sulla mappa");
    return false;
  }
  setMapError("");
  return true;
};

export const validateSubAreas = (data) => {
  if (!data || data.hasSubAreas === false) {
    return null;
  }

  if (
    !data.subAreas ||
    !Array.isArray(data.subAreas) ||
    data.subAreas.length === 0
  ) {
    return "E' necessario aggiungere almeno un sottoterreno.";
  }

  const errors = {};

  data.subAreas.forEach((subArea, index) => {
    const subAreaErrors = {};

    if (!subArea.subAreaName) {
      subAreaErrors.subAreaName = "Il nome del sottoterreno è obbligatorio.";
    }
    if (!subArea.subAreaType) {
      subAreaErrors.subAreaType =
        "La tipologia del sottoterreno è obbligatoria.";
    }
    if (!subArea.subPolygonCoordinates) {
      subAreaErrors.subPolygonCoordinates = "Il sottopoligono è obbligatorio.";
    }

    if (Object.keys(subAreaErrors).length > 0) {
      errors[`subArea_${index}`] = subAreaErrors;
    }
  });

  return Object.keys(errors).length > 0 ? errors : null;
};

export const validateSingleSubArea = (
  subArea,
  mainPolygonCoordinates = null
) => {
  const errors = {};

  if (!subArea.subAreaName) {
    errors.subAreaName = "Il nome del sottoterreno è obbligatorio.";
  }
  if (!subArea.subAreaType) {
    errors.subAreaType = "La tipologia del sottoterreno è obbligatoria.";
  }
  if (!subArea.subPolygonCoordinates) {
    errors.subPolygonCoordinates = "Il sottopoligono è obbligatorio.";
  } else if (
    mainPolygonCoordinates &&
    !isPolygonWithinBounds(
      subArea.subPolygonCoordinates,
      mainPolygonCoordinates
    )
  ) {
    errors.subPolygonCoordinates =
      "Il sottoterreno deve essere contenuto nel terreno principale.";
  }

  return Object.keys(errors).length > 0 ? errors : null;
};
